import { SvgIcon } from '@mui/material';

export default function BackArrowIcon(props: any) {
  return (
    <SvgIcon {...props} viewBox="0 0 25 25" style={{ ...props.style }}>
      <path
        d="M19.1348 12.5215L5.13477 12.5215"
        stroke={props.color ?? props.style?.color ?? `#2E3744`}
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.1348 19.5215L5.13477 12.5215L12.1348 5.52148"
        stroke={props.color ?? props.style?.color ?? `#2E3744`}
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}
